import { Feature } from 'ol';
import { GeoJSONFeature } from 'ol/format/GeoJSON';
import { Polygon } from 'ol/geom';
import { Interaction } from 'ol/interaction';
import { InteractionOptions as BaseOptions } from 'ol/interaction/Interaction';

import MapController from '@/shared/lib/openlayers/MapController';
import TickEvent from '@/shared/lib/openlayers/interaction/event/TickEvent';

export interface InteractionExtraOptions {
  hasSnap?: boolean;
  hasSelection?: boolean;
  selectionRequired?: boolean;
}

export type SelectedGeometryType = Polygon;
export type SelectionType = Feature<SelectedGeometryType>;

export interface InteractionOptions extends BaseOptions {
  selected?: SelectionType;
}

export abstract class AbstractInteraction extends Interaction {
  options: InteractionOptions;
  mapController: MapController;
  selected?: SelectionType;

  static getIdentifier(): string {
    throw new Error('Get identifier not implemented');
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  static visibilityCondition(selected: SelectionType): boolean {
    return true;
  }

  static getExtraOpts(): InteractionExtraOptions {
    return {};
  }

  asGeoJSON(feature: Feature): GeoJSONFeature {
    return JSON.parse(this.mapController.geojson.writeFeature(feature));
  }

  constructor(opts: InteractionOptions, mapController: MapController) {
    super(opts);
    this.options = opts;
    this.mapController = mapController;
    this.selected = this.options.selected;
  }

  setFeatureDirty(feature: Feature) {
    feature.setProperties({
      ...feature.getProperties(),
      dirty: true,
    });
    this.mapController.dispatchEvent(new TickEvent(this.asGeoJSON(feature)));
  }

  protected getSelected(): SelectionType {
    if (!this.selected) {
      throw new Error('Selection required');
    }

    return this.selected;
  }

  protected getSelectedGeometry(): SelectedGeometryType {
    return this.getSelected().getGeometry() as any;
  }
}
